import React, { useContext, useEffect, useState } from "react";
import { Link, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Box, Button, IconButton, CircularProgress } from '@mui/material'
import { Close, Upload } from '@mui/icons-material';
import AppContext from "../../utils/app-context.js";
import { nanoid } from "nanoid";
import toast from "react-hot-toast";
import Loading from "../loading.js";
import AuthBox from "../auth-box.js";


export default function LoginDialog(props) {
    const { state } = useContext(AppContext);
    const isLoggedIn = Object.keys(state.userData).length != 0 ? true : false;
    
    useEffect(() => {
        if (isLoggedIn && props.open && props.onClose) {
            props.onClose();
        }
    }, [isLoggedIn, props.open, props.onClose]);

    return (
     <Dialog
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{props.title || "Log in"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          </DialogContentText>
          <AuthBox version="login-modal" redirect={props.redirect} authFunc={props.authFunc} 
            value_prop={props.value} />
        </DialogContent>
      </Dialog>
    );
} 